export const ADE_CADASTRE_MAPPING_VERSION = "ade-cadastre/v4";
export const ADE_CADASTRE_ZERO_AREA_EXCLUSION_POLICY_V1 = {
    contractVersion: "ade-cadastre-geometry-exclusion-policy/v1",
    entries: [
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "ee902d5217845146123db817cebd99c2794d3c880bcc8597442edbf35f89fef6",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_LineString",
            referenceSha256: "23330120dbc8030d38749ec0e3f950921eee8417bd34e25753b13291aa8a7c25",
            sourceRecordOffset: {
                archivePath: "MO.zip!/C951_CONCORDIA SULLA SECCHIA.zip!/C951_CONCORDIA SULLA SECCHIA_ple.gml",
                gmlMember: 10_210
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "54937589eb7700365ae3648eddec0b396884523c2c189eb5985b018f5d36fa54",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_MultiLineString",
            referenceSha256: "74707b79f8774a5e9fe44cd8af5829dce41868edb725815323d9cdf3547be83d",
            sourceRecordOffset: {
                archivePath: "MO.zip!/G393_PAVULLO NEL FRIGNANO.zip!/G393_PAVULLO NEL FRIGNANO_ple.gml",
                gmlMember: 43_853
            }
        }
    ],
    mappingVersion: "ade-cadastre/v2",
    sourceArtifactSha256: "0e4caefb1080fe25e94e1ccca0de2d20cb0303b151ada1813152c2cbd61ba795",
    sourceKey: "ade.cadastral-cartography"
};
export const ADE_CADASTRE_ZERO_AREA_EXCLUSION_POLICY_V2 = {
    contractVersion: "ade-cadastre-geometry-exclusion-policy/v2",
    entries: [
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "5807344cb48a6165e48793b12114afe8d40083369a2f03a3b5264ab9c0d7c566",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_LineString",
            referenceSha256: "8f235bb79a3288d2ecc51ca3fb1859cd1318604c943d261b5a84d765c486cfe1",
            sourceRecordOffset: {
                archivePath: "BO.zip!/F597_MONTERENZIO.zip!/F597_MONTERENZIO_ple.gml",
                gmlMember: 16_257
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "5ede3b2eae3529001158d6a31469d70b99c84d56f54d9e82e223e60385268e91",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_MultiLineString",
            referenceSha256: "d9e61522b62d5de34509752303a74b36ee400210d7fc56c64942336118da2280",
            sourceRecordOffset: {
                archivePath: "BO.zip!/G570_PIANORO.zip!/G570_PIANORO_ple.gml",
                gmlMember: 21_040
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "af665cefa7c895b49693c2d47c65d556a90974003c22c679c7f63ea4ef808b9d",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_LineString",
            referenceSha256: "a3e39eb23020a688847de6e05d29627beb006a4ae07f3c24b2feda594003a300",
            sourceRecordOffset: {
                archivePath: "BO.zip!/G570_PIANORO.zip!/G570_PIANORO_ple.gml",
                gmlMember: 21_042
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "1c2655caf8fb26b73613cd398925dd691df5d8fa2d1c30c5f7115ce31c72a7fb",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_MultiLineString",
            referenceSha256: "b5aedf1f59c4317c348f0d62ff921dd7ac177042366f4afa0406e7ec0ad754b8",
            sourceRecordOffset: {
                archivePath: "FE.zip!/A393_ARGENTA.zip!/A393_ARGENTA_ple.gml",
                gmlMember: 4_233
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "88237e1812ab3970163ea2eadf5282ecf88e401c3b4be312c77cbb839211cc62",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_MultiLineString",
            referenceSha256: "22955c5882504b0980164fe5ea0355f02b2609b300cca2d9c888b735f52a3501",
            sourceRecordOffset: {
                archivePath: "FE.zip!/C980_COPPARO.zip!/C980_COPPARO_ple.gml",
                gmlMember: 15_943
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "0507fd0a3c4cb1ca6497fa5916e13eb53f3faa019040a67ef6abec237d63cd34",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_LineString",
            referenceSha256: "b4c2e30b58c7edc619a18334276f5948ec834ab17d31c5781fc948d29c61b139",
            sourceRecordOffset: {
                archivePath: "FO.zip!/I779_SOGLIANO AL RUBICONE.zip!/I779_SOGLIANO AL RUBICONE_ple.gml",
                gmlMember: 20_910
            }
        },
        ...ADE_CADASTRE_ZERO_AREA_EXCLUSION_POLICY_V1.entries,
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "75f6de182952af0b870e3b82e599f51d2dc42a90a227a338013791a1cd08ec9d",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_LineString",
            referenceSha256: "8f33a698fb0c4fdc131efdeee8e7575622bf4fadf3fe11d9dc94f48bcf28f407",
            sourceRecordOffset: {
                archivePath: "PC.zip!/G535_PIACENZA.zip!/G535_PIACENZA_ple.gml",
                gmlMember: 33_464
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "fe8fe34f1184c4eae5b08b7e78aa7134828ae807619f5d4ab53219c4facdf8cb",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_MultiLineString",
            referenceSha256: "6455e8823d804b95e9302963834222861587cc4f6bbcaeee6f4176c0b9cccad6",
            sourceRecordOffset: {
                archivePath: "PC.zip!/L348_TRAVO.zip!/L348_TRAVO_ple.gml",
                gmlMember: 13_989
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "291aafd756c890949efee7af8144206153de973442505ced65d95762b1de3d4d",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_MultiLineString",
            referenceSha256: "0821afaa4fb4c89c92ae6fd4ec62985902f4a04fc9c22712399fb3bba441714c",
            sourceRecordOffset: {
                archivePath: "PR.zip!/E547_LESIGNANO DE` BAGNI.zip!/E547_LESIGNANO DE` BAGNI_ple.gml",
                gmlMember: 120
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "09acaebfcb6cd734e2161d46dd36b704b1760b378f8dd6c3654c1e778a49a7ee",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_LineString",
            referenceSha256: "bfda6d917ae8a9dd3152422bd4338124941e8351eb8da5022e8eedf14e5c6327",
            sourceRecordOffset: {
                archivePath: "PR.zip!/I840_SORAGNA.zip!/I840_SORAGNA_ple.gml",
                gmlMember: 5_170
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "01d5b04c3cd8e0449e9668b373ef5ceb88c8ad1ea4de1ce6dbd96cda553a9fa4",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_MultiLineString",
            referenceSha256: "a5caefba3c555f69da522eea076af153bddbbdce8b817d1acd79b8c928544c43",
            sourceRecordOffset: {
                archivePath: "PR.zip!/L346_TRAVERSETOLO.zip!/L346_TRAVERSETOLO_ple.gml",
                gmlMember: 3_463
            }
        },
        {
            code: "GEOMETRY_REJECTED",
            externalIdSha256: "a585d90d1b815ebaf5f272e4534bcfe61486a0e3c29a938ff0b9bf7b4612ee41",
            layerKey: "CADASTRAL_PARCEL",
            reason: "unsupported_geometry_LineString",
            referenceSha256: "459a197b837d05eb81b87e25d750b21f5ba5e558254722c341714fa75e2e98e5",
            sourceRecordOffset: {
                archivePath: "RA.zip!/H199_RAVENNA.zip!/H199_RAVENNA_ple.gml",
                gmlMember: 92_858
            }
        }
    ],
    mappingVersion: "ade-cadastre/v3",
    sourceArtifactSha256: "0e4caefb1080fe25e94e1ccca0de2d20cb0303b151ada1813152c2cbd61ba795",
    sourceKey: "ade.cadastral-cartography"
};
export const ADE_CADASTRE_ZERO_AREA_EXCLUSION_POLICY_V3 = {
    ...ADE_CADASTRE_ZERO_AREA_EXCLUSION_POLICY_V2,
    contractVersion: "ade-cadastre-geometry-exclusion-policy/v3",
    mappingVersion: "ade-cadastre/v4"
};
export const ADE_CADASTRE_ZERO_AREA_EXCLUSION_POLICY = ADE_CADASTRE_ZERO_AREA_EXCLUSION_POLICY_V3;
//# sourceMappingURL=ade-cadastre-exclusion-policy.js.map